module.exports = __webpack_public_path__ + "static/media/round-timer-07.1e13f9e9.svg";